import { APIConnector, Settings } from "../base";

const apiConnector = new APIConnector({ timeout: 40000 });

export default class BoletaConfig {
	static get baseDomain() {
		return Settings.serverDomain;
	}

	static get endpoint() {
		return Settings.server + "/ticketHeaders";
	}

	static get endpointTmp() {
		return `${BoletaConfig.baseDomain}/tmp`;
	}

	static get endpointProcessFile() {
		return `${BoletaConfig.endpoint}/process-file`;
	}

	static get endpointPrintTicket() {
		return `${BoletaConfig.endpoint}/print-ticket`;
	}

	static get endpointRegenerateTicket() {
		return `${BoletaConfig.endpoint}/regenerate-ticket`;
	}

	static get endpointSetTicketAsPaid() {
		return `${BoletaConfig.endpoint}/set-as-paid`;
	}

	static get endpointTicketOnDemand() {
		return `${BoletaConfig.endpoint}/on-demand`;
	}

	static get endpointRegenerateTicketOnDemand() {
		return `${BoletaConfig.endpoint}/regenerate-ticket-on-demand`;
	}

	static get endpointUpdateBoletas() {
		return `${BoletaConfig.endpoint}`;
	}

	static get endpointGetMovement() {
		return `${BoletaConfig.endpoint}/movements`;
	}

	static get endpointProcessTxt() {
		return `${Settings.server}/partial-payments/process-txt`;
	}

	static get APIConnector() {
		return apiConnector;
	}
}



// WEBPACK FOOTER //
// ./src/provider/Boleta/BoletaConfig.js